import { appPath } from '@featit/shared/addressing/paths';

/**
 * Where a signed-in reader starts: the app's home, under `/-/` (ADR-133, T-0344).
 *
 * The root `/` is not the app's to answer on the cloud: the edge serves it the app only when the
 * presence cookie says somebody is signed in here, and otherwise sends the visitor to the website.
 * So the app never sends anybody *to* `/` — it names its home here, and the root route keeps only
 * the old links working, forwarding them here.
 */
export const APP_HOME_PATH = appPath('/items');
